import { MedicalQuestionType } from "@/utils/schema/gatekeeper-question-page-schema.utils";

export const LandingPage = "eligibility";
export const QuestionOne = "cover-type";
export const QuestionTwo = "travelling-from";
export const QuestionThree = "travelling-to";
export const QuestionFour = "cruise";
export const QuestionSeven = "organiser";
export const QuestionEight = "travellers";
export const RequiredInformation = "required-information";
export const QuestionFive = "travel-dates";
export const QuestionSix = "cover-for";
export const QuestionMedical = "question-medical";
export const QuestionMedicalPMI = "private-medical-insurance";
export const QuestionMedicalConfirmation = "medical-confirmation";
export const QuestionMedicalConfirmationv2 = "medical-confirmation-v2";
export const QuestionMedicalEligibility = "medical-eligibility";
export const QuestionMedicalConditions = "medical-conditions";
export const QuestionMedicalTreatments = "medical-treatments";
export const QuestionMedicalTreatmentsv2 = "medical-treatments-v2";
export const MedicalScreen = "medical-screen";
export const MainView = "main-view";
export const QuestionDisable = "question-disable";
export const MedicalLandingPage = "traveller-health";
export const MedicalLanding = "medical-landing";
export const MedicalDashboard = "medical-dashboard";
export const MedicalNothingToDeclare = "medical-no-declare";
export const NotFound = "/not-found";
export const ContactDetails = "contact-details";
export const Address = "address";
export const Review = "review";
export const QuoteDecline = "unable-to-quote";
export const MTADeclined = "mta-creation-error";
export const PostalSettings = "PostalSettings";
export const QuoteReview = "quote-review";
export const ReviewAutoRenewal = "review-auto-renewal";
export const Quote = "quote";
export const YouAreNowCovered = "you-are-now-covered";
export const Payment = "payment";
export const PolicyDocument = "policy-document";
export const WithdrawalVerification = "withdrawal-verification";
export const RenewalNextYearRenew = "renewal-next-year-renew";

export const RenewSingleEdit = "RENEW_SINGLE_EDIT";

export const RenewalPage = "renewal";
export const RenewalPolicyExtras = "renewal-policy-extras";
export const RenewalCurrentPolicy = "current-policy";
export const RenewalCoverLevel = "cover-level";
export const RenewalReview = "review";
export const RenewalPaymentSummary = "payment-summary";
export const RenewalPremiumPayment = "premium-payment";
export const RenewalEditPolicyExtras = "edit-policy-extras";
export const RenewalEditOrganizer = "organiser-edit";
export const RenewalConfirmation = "confirmation";

export const SessionSuccessPage = "SuccessPage";

// question two const
export const SingleTrip = "SINGLE_TRIP";
export const AnnualMultiTrip = "ANNUAL_MULTI_TRIP";
export const NotSure = "NOT_SURE";

export const UKOnly = "UK";
export const IrelandOnly = "IE";
export const SpainOnly = "ESP";
export const Europe = "EUROPE";
export const Worldwide = "WORLD";
export const EuropeHR = "EUROPE_HR";
export const EuropeLR = "EUROPE_LR";
export const WorldwideHR = "WORLD_HR";
export const WorldwideLR = "WORLD_LR";
export const UK1 = "UK1";
export const UK3 = "UK3";
export const UK4 = "UK4";
export const Spain = "spain";
export const France = "france";
export const Portugal = "portugal";
export const UK5 = "UK5";
export const SPAIN_ES = "ES";
export const FRANCE_FR = "FR";
export const PORTUGAL_PT = "PT";

// cover type

export const TrustpilotAPIKey = process.env.NEXT_PUBLIC_TRUST_PILOT_API_KEY;

// question four
export const SAME_LOCATION = "SameLocation";
export const SAME_DAY = "SameDay";

// question five
export const Individual = "INDIVIDUAL";
export const Couple = "COUPLE";
export const Family = "FAMILY";
export const SingleParentFamily = "SINGLE_PARENT_FAMILY";
export const Group = "OTHER";

// Add Medical constants
export const QUOTE_JOURNEY_TYPE =
  process.env.NEXT_PUBLIC_APPLICATION === "renewal" ? "Renewal" : "Quote";
export const QUOTE_CHANNEL_ONLINE = "ONLINE";
export const QUOTE_DOMAIN_STS = "STS";
export const MEDICAL_REQUEST_ADD = "ADD";
export const MEDICAL_REQUEST_EDIT = "EDIT";
export const MEDICAL_REQUEST_REDIRECT_URL = `${process.env.NEXT_PUBLIC_HOME_URI}/medical-dashboard`;
export const THIRDPARTYRESPONSE_TYPE = "Medical";

// edit quote constants
export const CruiseEdit = "cruiseEdit";
export const QuoteEdit = "editQuote";
export const DatesEdit = "datesEdit";
export const DestinationEdit = "destinatinEdit";
export const MedicalEdit = "medicalEdit";
export const TravellerEdit = "travellerEdit";
export const ContactEdit = "contactsEdit";
export const CoverEdit = "coverEdit";
export const OrganizerEdit = "organizerEdit";

// finish edit button
export const FinishEdit = "Finish editing";

export const CancelEdit = "Cancel editing";
export const ContinueBtn = "Continue";

// FCDO countries

export const fcdoCountryList = [
  "NE",
  "SO",
  "TD",
  "YE",
  "CF",
  "ML",
  "AF",
  "IQ",
  "LY",
  "SY",
  "BF",
  "IR",
  "AN",
  "RU",
  "LB",
  "UA",
  "BY",
  "HT",
  "SD",
  "VE",
  "PS",
  "IL",
];

export const medicalUsagePageQuestionTypes: Record<
  string,
  MedicalQuestionType
> = {
  "medical-confirmation": MedicalQuestionType.Confirmation,
  "medical-conditions": MedicalQuestionType.Conditions,
  "medical-treatments": MedicalQuestionType.Treatments,
  "medical-eligibility": MedicalQuestionType.Eligibility,
};

export enum Brand {
  STAYSURE = "staysure",
  AVANTI = "avanti",
  EXPAT = "expat",
}

export const GOLF_YEAR_PRICE = {
  avanti: 11.28,
  staysure: 32.95,
} as const;

export const CONSENT_YES_MODAL = "consent-yes-modal";
export const CONSENT_NO_MODAL = "consent-no-modal";
export const CONSENT_MODAL = "consent-modal";
export const CONSENT_YES_MODAL_WITH_ZERO_VALUE = "consent-yes-value-zero-modal";
export const CONSENT_CREATION_ERROR_MODAL = "consent-creation-error-modal";
export const WORLDWIDE_LOCATION = "worldwide-location";

export enum QuoteErrorCodesEnum {
  EXPIRED = 1069,
  ALREADY_PURCHASED = 1079,
  INVALID_START_DATE = 1076,
  FCDO_RESTRICTED = 1092,
  TRIP_LIMITATION_AGE = 1112,
  MEDICAL_DECLINED = 1061,
}

export const EDITABLE_ERROR_CODES = [
  QuoteErrorCodesEnum.INVALID_START_DATE,
  QuoteErrorCodesEnum.FCDO_RESTRICTED,
];

export const TURNSTILE_PATHS_TO_VISIBLE = [
  "",
  QuestionTwo,
  QuestionThree,
  QuestionFour,
  QuestionFive,
  QuestionSix,
  QuestionSeven,
  QuestionEight,
];

export const TURNSTILE_INIT_PATHS = ["", QuestionSeven, QuestionEight];
export enum TurnstileBEErrorCodesEnum {
  INVALID_SECRET = 4099,
  TOKEN_INVALID = 4100,
  REQUEST_MALFORMED = 4101,
  TOKEN_ALREADY_VALIDATED = 4102,
  INTERNAL_ERROR = 4103,
  TOKEN_VALIDATION_FAILED = 4104,
}

export enum TurnstileFEErrorCodesEnum {
  FE_INIT_ERROR = "300030",
}

export const USER_DISPLAYED_TURNSTILE_ERRORS = [
  TurnstileBEErrorCodesEnum.INVALID_SECRET,
  TurnstileBEErrorCodesEnum.TOKEN_INVALID,
  TurnstileBEErrorCodesEnum.REQUEST_MALFORMED,
  TurnstileBEErrorCodesEnum.TOKEN_ALREADY_VALIDATED,
  TurnstileBEErrorCodesEnum.INTERNAL_ERROR,
  TurnstileBEErrorCodesEnum.TOKEN_VALIDATION_FAILED,
];

export const USER_HIDDEN_TURNSTILE_ERRORS: TurnstileFEErrorCodesEnum[] = [];

export const TurnstileSiteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
export const TurnstileSiteKeyAutomation =
  process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY_AUTOMATION;
export const TurnstileSiteKeyBotEmulated =
  process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY_BOT_EMULATE;

export enum OptimizelyExperimentsEnum {
  UNDIAGNOSED = "ud_flow",
  TURNSTILE = "turnstile_enabled",
  ST_AMT_UP_SELL = "stAmtUpsellFlow",
  QUOTE_TABLE_MOBILE = "mobile_quote_table",
  QUESTION_ORDER = "contactPageShiftFlow",
  RENEWAL_DASHBOARD_COVER_LEVEL_SECTION = "renewalDashBoardCoverLevelSection",
  RENEWAL_COVER_LEVEL = "coverLevelPageRenewal",
  RENEWAL_DASHBOARD_ALL_COVER_LEVEL = "renewalDashboardAllCoverLevel",
  RENEWAL_COVER_LEVEL_CHIP = "coverLevelPageRenewalChip",
  RENEWAL_CURRENT_POLICY_PAGE_SKIP = "renewalCurrentPolicyPageSkip",
  SINGLE_TRIP_AMT_MODAL_REMOVAL = "singleTripAmtModalRemoval",
  MEDICAL_ELIGIBILITY_FLOW = "medicalEligibilityFlow",
  CANCELLATION_COVER_DROPDOWN = "cancellationCoverDropdown",
  HIDE_ORGANISER_PERSONAL_DETAILS = "experiment-hide-personal-detail",
  PRICE_TOGGLE_EXPERIMENT = "priceToggleExperiment",
  AMT_TO_ST_MODAL_REMOVAL = "amtToStModalRemoval",
  PROMO_BANNER = "promo_banner",
  MEDICAL_NO_TO_DASHBOARD = "medicalNoToDashboard",
}

export const SUPPORT_SECTION_STICKY_ENABLED = [QuestionSeven, QuestionEight];

export const ELIGIBLE = "ELIGIBLE";
export const WITHDRAWAL_REQUESTED = "REQUESTED";
export const NOT_ELIGIBLE = "NOT_ELIGIBLE";
export const REJECTED = "REJECTED";
export const WITHDRAWN = "WITHDRAWN";
